import { type GetterTree } from 'vuex';

import { type IApplicationState, type IDirectoryAssetExpansion, type IDirectoryCompanyExpansion, type ISettingsExpansion } from './types';

export const GET_PARTNER_STATUS = 'getPartnerStatus';
export const GET_CURRENT_BRIEF_ID = 'getCurrentBriefId';
export const GET_RECENT_COMPANY_BOARD_ID = 'getRecentCompanyBoardId';
export const GET_RECENT_LEAD_BOARD_ID = 'getRecentBoardId';
export const GET_RECENT_MEETING_BOARD_ID = 'getRecentMeetingBoardId';
export const GET_RECENT_AGREEMENT_BOARD_ID = 'getRecentAgreementBoardId';
export const GET_RECENT_ALLIANCE_BOARD_ID = 'getRecentAllianceBoardId';
export const GET_RECENT_OBLIGATION_BOARD_ID = 'getRecentObligationBoardId';
export const GET_CURRENT_LEAD_ID = 'getCurrentLeadId';
export const GET_MEETING_LIST_VIEW = 'getMeetingListView';
export const GET_RECENT_VIEWED_LEADS_IDS = 'getRecentViewedLeadsIds';
export const GET_RECENT_VIEWED_COMPANIES_IDS = 'getRecentViewedCompaniesIds';
export const GET_RECENT_VIEWED_BRIEFS_IDS = 'getRecentViewedBriefsIds';
export const GET_RECENT_VIEWED_CAMPAIGNS_IDS = 'getRecentViewedCampaignsIds';
export const GET_SETTINGS_EXPANSION = 'getSettingsExpansion';
export const GET_DIRECTORY_COMPANY_EXPANSION = 'getDirectoryCompanyExpansion';
export const GET_DIRECTORY_ASSET_EXPANSION = 'getDirectoryAssetExpansion';
export const GET_ALLOW_NAVIGATION = 'getAllowNavigation';
export const GET_EMAIL_PREVIEW_TEXT = 'getEmailPreviewText';

export const getters: GetterTree<IApplicationState, unknown> = {
    [GET_PARTNER_STATUS]: (_state): string | undefined => {
        return _state.partnerStatus;
    },
    [GET_CURRENT_BRIEF_ID]: (_state): number | undefined => {
        return _state.currentBriefId;
    },
    [GET_EMAIL_PREVIEW_TEXT]: (_state): boolean => {
        return _state.emailPreviewText;
    },
    [GET_RECENT_LEAD_BOARD_ID]: (_state, _getters, _rootState, _rootGetters) => {
        return (userKey: string): number | undefined => {
            return _state.recentLeadBoardId.get(userKey);
        };
    },
    [GET_RECENT_MEETING_BOARD_ID]: (_state, _getters, _rootState, _rootGetters) => {
        return (userKey: string): number | undefined => {
            return _state.recentMeetingBoardId.get(userKey);
        };
    },
    [GET_RECENT_COMPANY_BOARD_ID]: (_state, _getters, _rootState, _rootGetters) => {
        return (userKey: string): number | undefined => {
            return _state.recentCompanyBoardId.get(userKey);
        };
    },
    [GET_RECENT_AGREEMENT_BOARD_ID]: (_state, _getters, _rootState, _rootGetters) => {
        return (userKey: string): number | undefined => {
            return _state.recentAgreementBoardId.get(userKey);
        };
    },
    [GET_RECENT_ALLIANCE_BOARD_ID]: (_state, _getters, _rootState, _rootGetters) => {
        return (userKey: string): number | undefined => {
            return _state.recentAllianceBoardId.get(userKey);
        };
    },
    [GET_RECENT_OBLIGATION_BOARD_ID]: (_state, _getters, _rootState, _rootGetters) => {
        return (userKey: string): number | undefined => {
            return _state.recentObligationBoardId.get(userKey);
        };
    },
    [GET_RECENT_VIEWED_LEADS_IDS]: (_state) => {
        return (userKey: string): number[] | undefined => {
            return _state.recentViewedLeadsIds.has(userKey) ? _state.recentViewedLeadsIds.get(userKey) : [];
        };
    },
    [GET_MEETING_LIST_VIEW]: (_state) => {
        return (userKey: string): string | undefined => {
            return _state.meetingListView.has(userKey) ? _state.meetingListView.get(userKey) : undefined;
        };
    },
    [GET_RECENT_VIEWED_COMPANIES_IDS]: (_state) => {
        return (userKey: string): number[] | undefined => {
            return _state.recentViewedCompaniesIds.has(userKey) ? _state.recentViewedCompaniesIds.get(userKey) : [];
        };
    },
    [GET_RECENT_VIEWED_BRIEFS_IDS]: (_state) => {
        return (userKey: string): number[] | undefined => {
            return _state.recentViewedBriefsIds.has(userKey) ? _state.recentViewedBriefsIds.get(userKey) : [];
        };
    },
    [GET_RECENT_VIEWED_CAMPAIGNS_IDS]: (_state) => {
        return (userKey: string): number[] | undefined => {
            return _state.recentViewedCampaignsIds.has(userKey) ? _state.recentViewedCampaignsIds.get(userKey) : [];
        };
    },
    [GET_ALLOW_NAVIGATION]: (_state): boolean => {
        return _state.allowNavigationSet.size === 0;
    },
    [GET_SETTINGS_EXPANSION]: (_state) => {
        return (userKey: string): ISettingsExpansion => {
            return (
                _state.settingsExpansion.get(userKey) ?? {
                    direct: true,
                    milestones: true,
                    leads: true,
                    briefs: true,
                    contributor: true,
                    agreements: true,
                    alliances: true,
                    obligations: true
                }
            );
        };
    },
    [GET_DIRECTORY_COMPANY_EXPANSION]: (_state) => {
        return (userKey: string): IDirectoryCompanyExpansion => {
            return (
                _state.directoryCompanyExpansion.get(userKey) ?? {
                    companyDetails: true,
                    companyFinancial: true
                }
            );
        };
    },
    [GET_DIRECTORY_ASSET_EXPANSION]: (_state) => {
        return (userKey: string): IDirectoryAssetExpansion => {
            return (
                _state.directoryAssetExpansion.get(userKey) ?? {
                    assetDetails: true,
                    assetPublications: true
                }
            );
        };
    }
};
